export default "__VITE_ASSET__CWtHleqh__"